import Bildungsgutschein from "./Bildungsgutschein";

export default Bildungsgutschein;
